<ng-container *ngIf="shoppingCartItems$ | async as items">
	<div class="app-shopping-cart__content d-flex flex-column p-3" [ngClass]="{'app-shopping-cart__content--mobile' : mobile$ | async}">
		<div class="d-flex">
			<div class="flex-grow-1">
				<h1 i18n class="mat-headline-6">Ausgewählte Elemente</h1>
			</div>

			<button mat-icon-button (click)="closeShoppingCart.emit()">
				<mat-icon fontSet="voest-icons__close"></mat-icon>
			</button>
		</div>

		<div>
			<p class="mb-5">{{numberOfItems$ | async}} <span i18n>Element(e) ausgewählt</span></p>

			<app-shopping-cart-item *ngFor="let item of items"
															[item]="item"
															(removeItem)="removeItemFromCart($event)"
															(updateItem)="updateTotalCost()"></app-shopping-cart-item>
		</div>
	</div>

	<div *ngIf="items.length" [ngClass]="{'app-shopping-cart__footer--mobile' : mobile$ | async}" class="app-shopping-cart__footer px-3">
		<mat-divider class="mb-3"></mat-divider>

		<p *ngIf="totalCost$ | async as total" class="mat-headline-6">
			<span i18n>Summe</span>: {{total | currency:'EUR':'symbol':'1.2-2'}}
		</p>

		<button type="button" mat-flat-button color="accent" class="u-full-width mb-3" i18n
						(click)="exportCsv(items)">CSV exportieren</button>

		<button type="button" mat-flat-button color="accent" class="u-full-width  mb-3" i18n
						(click)="exportPdf(items)">PDF exportieren</button>

		<div *ngIf="(isLoggedIn$ | async) === true" class="u-full-width mb-3">
			<a mat-flat-button color="primary" class="u-full-width"
				 (click)="openSaveArticleListDialogue(items)" i18n>Auswahl speichern</a>
		</div>

		<div class="u-full-width">
			<a mat-stroked-button color="warn" class="u-full-width" (click)="resetCart()" i18n>Auswahl zurücksetzen</a>
		</div>
	</div>
</ng-container>
